import {
    useContext,
    useEffect
} from "react";
import type {
    SidebarContextType
} from "./type";
import {
    SidebarContext
} from "./context";
import {
    warnOnce
} from "../../utils/development";

const SIDEBAR_FALLBACK_CONTEXT: SidebarContextType = {
    handleOpenChange: () => undefined,
    handleToggle: () => undefined,
    variant: "sidebar",
    state: "expanded",
    isPhone: false,
    shortcut: null,
    sidebarId: "",
    isOpen: true
};

const useSidebar = (): SidebarContextType => {
    const context = useContext(SidebarContext);

    useEffect(() => {
        if(context) {
            return;
        }

        warnOnce({
            message: "Sidebar.useContext must be called inside Sidebar.Provider."
        });
    }, [
        context
    ]);

    return context ?? SIDEBAR_FALLBACK_CONTEXT;
};
export default useSidebar;
